module.exports = global["jQuery"] = require("-!C:\\Users\\User\\projects\\mazay\\node_modules\\source-map-loader\\index.js!C:\\Users\\User\\projects\\mazay\\node_modules\\source-map-loader\\index.js!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/source-map-loader!./~/jquery/dist/jquery.js-exposed
// module id = 3
// module chunks = 0